import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { CLIENT_PRE_QUESTION } from "../config/apiEndPoint";
import { GET, POST, DEL } from "config/api.config";

export const getClientPreQuestionList = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${CLIENT_PRE_QUESTION.GET_CLIENT_PRE_QUESTION_LIST}/${data?._Id}`
      : `${CLIENT_PRE_QUESTION.GET_CLIENT_PRE_QUESTION_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addClientPreQuestion = async (data = array()) => {
  try {
    const response = await POST(CLIENT_PRE_QUESTION.UPSERT_CLIENT_PRE_QUESTION, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateClientPreQuestion = async (id, data = array()) => {
  try {
    const response = await POST(CLIENT_PRE_QUESTION.UPSERT_CLIENT_PRE_QUESTION, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getClientPreQuestionDataById = async (data = array()) => {
  try {
    const url = data?.Id
      ? `${CLIENT_PRE_QUESTION.GET_CLIENT_PRE_QUESTION_LIST}/${data?.Id}`
      : `${CLIENT_PRE_QUESTION.GET_CLIENT_PRE_QUESTION_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchClientPreQuestionTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${CLIENT_PRE_QUESTION.GET_CLIENT_PRE_QUESTION_SCHEMA}/${data?._Id}`
      : `${CLIENT_PRE_QUESTION.GET_CLIENT_PRE_QUESTION_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitClientPreQuestionFilterData = async (data = array()) => {
  try {
    const response = await POST(CLIENT_PRE_QUESTION.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getJobByClient = async (clientId = "") => {
  try {
    const url = clientId
      ? `${CLIENT_PRE_QUESTION.GET_JOB_BY_CLIENT}/${clientId}/jobs`
      : `${CLIENT_PRE_QUESTION.GET_JOB_BY_CLIENT}`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getClientPreQuestionForEdit = async (clientId = "", jobId = "") => {
  try {
    const url =
      clientId && jobId
        ? `${CLIENT_PRE_QUESTION.GET_CLIENT_PRE_QUESTION_FOR_EDIT}/${clientId}/${jobId}`
        : `${CLIENT_PRE_QUESTION.GET_CLIENT_PRE_QUESTION_FOR_EDIT}`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `client/ClientPreQuestion/{id}/reset-master-sort` */
export const resetClientPreQuestionMasterSort = async (id = "") => {
  const raw = String(id ?? "").trim();
  if (!raw) {
    toast.error("Pre question ID is required");
    return;
  }
  try {
    const url = `${CLIENT_PRE_QUESTION.RESET_MASTER_SORT}/${encodeURIComponent(raw)}/reset-master-sort`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** DELETE `client/ClientPreQuestion/{id}` */
export const deleteClientPreQuestion = async (id = "") => {
  const raw = String(id ?? "").trim();
  if (!raw) {
    toast.error("Pre question ID is required");
    return;
  }
  try {
    const url = `${CLIENT_PRE_QUESTION.GET_CLIENT_PRE_QUESTION_LIST}/${encodeURIComponent(raw)}`;
    const response = await DEL(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
